import {useCallback, useEffect, useState} from "react";
import ColorSchemeService, {ColorScheme, ColorSchemePreference} from "services/ColorSchemeService";

/**
 * The active colour scheme. Components that draw on a canvas use it to redraw when it changes;
 * DOM styles follow it on their own through the CSS variable tokens.
 * @return {ColorScheme} "light" or "dark"
 */
export default function useColorScheme(): ColorScheme {
  const [scheme, setScheme] = useState<ColorScheme>(ColorSchemeService.getColorScheme());
  useEffect(() => {
    setScheme(ColorSchemeService.getColorScheme());
    return ColorSchemeService.subscribe(setScheme);
  }, []);
  return scheme;
}

/**
 * The user's appearance setting and its setter.
 * @return {[ColorSchemePreference, Function]} the preference and a function to change it
 */
export function useColorSchemePreference(): [ColorSchemePreference, (next: ColorSchemePreference) => void] {
  const [preference, setPreferenceState] = useState<ColorSchemePreference>(ColorSchemeService.getPreference());
  const setPreference = useCallback((next: ColorSchemePreference) => {
    ColorSchemeService.setPreference(next);
    setPreferenceState(next);
  }, []);
  return [preference, setPreference];
}
